import { render, staticRenderFns } from "./PopupMessage.vue?vue&type=template&id=7bfde756&"
import script from "./PopupMessage.vue?vue&type=script&lang=js&"
export * from "./PopupMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports